export const compressAndResizeImage = (file, maxSizeKB = 25, maxWidth = 1024, maxHeight = 1024) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      
      img.onload = () => {
        // Calculate new dimensions while maintaining aspect ratio
        let width = img.width;
        let height = img.height;
        
        if (width > height) {
          if (width > maxWidth) {
            height = Math.round((height * maxWidth) / width);
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = Math.round((width * maxHeight) / height);
            height = maxHeight;
          }
        }
        
        // Create canvas and draw resized image
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        
        // Convert to blob with quality adjustment
        const convertToBlob = (quality = 0.9) => {
          return new Promise((resolveBlob) => {
            canvas.toBlob(
              (blob) => {
                if (blob.size <= maxSizeKB * 1024 || quality <= 0.1) {
                  resolveBlob(blob);
                } else {
                  // Reduce quality and try again
                  convertToBlob(quality - 0.1).then(resolveBlob);
                }
              },
              'image/jpeg',
              quality
            );
          });
        };
        
        // Start with high quality and reduce if needed
        convertToBlob().then((blob) => {
          resolve(new File([blob], file.name, { type: 'image/jpeg' }));
        });
      };
      
      img.onerror = () => {
        // If there's an error, return the original file
        resolve(file);
      };
    };
    
    reader.onerror = () => {
      // If there's an error reading the file, return it as is
      resolve(file);
    };
    
    reader.readAsDataURL(file);
  });
};
